import React, { useContext } from 'react';
import { Box, TextField, MenuItem, Stack, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import { ColorModeContext } from '../../index';

const LIGHT_VARS = {
  "--canvas": "#FFFFFF",
  "--hairline": "#E4E9F0",
  "--border-radius": "6px",
  "--slate": "#6B7A90",
  "--edge-blue": "#1F6FEB",
};

const DARK_VARS = {
  "--canvas": "#0F1729",
  "--hairline": "rgba(255,255,255,0.14)",
  "--border-radius": "6px",
  "--slate": "#93A4BD",
  "--edge-blue": "#4C9AFF",
};

const TableFilterBar = ({
  searchQuery,
  onSearchChange,
  filters = [],
  onFilterChange,
  searchPlaceholder = "Search..."
}) => {
  const { mode } = useContext(ColorModeContext || { mode: "light" });
  const V = mode === "dark" ? DARK_VARS : LIGHT_VARS;

  return (
    <Box 
      style={V}
      sx={{ 
        p: { xs: 1, md: 2 }, 
        px: { xs: 0, md: 0 },
        backgroundColor: 'transparent', 
        border: 'none',
        mb: 1
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" useFlexGap>
        <TextField
          size="small"
          placeholder={searchPlaceholder}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          InputProps={{
            startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" sx={{ color: 'var(--edge-blue)' }} /></InputAdornment>,
            sx: { 
              borderRadius: '24px', 
              backgroundColor: mode === 'dark' ? '#252b3b' : '#FFFFFF',
              boxShadow: mode === 'dark' ? '0 2px 10px rgba(0,0,0,0.2)' : '0 2px 10px rgba(0,0,0,0.05)',
              '& fieldset': { border: '1px solid transparent' },
              '&:hover fieldset': { borderColor: 'var(--hairline)' },
              '&.Mui-focused fieldset': { borderColor: 'var(--edge-blue)' },
              minWidth: '320px',
              color: 'var(--vault-navy)',
              transition: 'all 0.3s ease'
            }
          }}
        />
        {filters.map((filter) => (
          <TextField
            key={filter.id}
            select
            size="small"
            label={filter.label}
            value={filter.value || ""}
            onChange={(e) => onFilterChange(filter.id, e.target.value)}
            sx={{ 
              minWidth: 160,
              '& .MuiInputBase-root': {
                borderRadius: '24px',
                backgroundColor: mode === 'dark' ? '#252b3b' : '#FFFFFF',
                boxShadow: mode === 'dark' ? '0 2px 10px rgba(0,0,0,0.2)' : '0 2px 10px rgba(0,0,0,0.05)',
                transition: 'all 0.3s ease',
                color: 'var(--vault-navy)',
              },
              '& fieldset': { border: '1px solid transparent' },
              '&:hover fieldset': { borderColor: 'var(--hairline)' },
              '& .Mui-focused fieldset': { borderColor: 'var(--edge-blue)' },
              '& .MuiSvgIcon-root': { color: 'var(--slate)' }
            }}
          >
            <MenuItem value="">
              <em>All</em>
            </MenuItem>
            {filter.options.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        ))}
      </Stack>
    </Box>
  );
};

export default TableFilterBar;
